<template>
    <div class="row" v-if="totalAmount !== '' && totalAmount !== false && totalAmount !== 0 && paymentArray !== []">
      <div class="col-md-12">
        <hr>
        <br>
        <div class="form-group authorize-elements">
          <div>
            <div class="margin-justified">
              <div v-for="(paymentPart, index) in paymentArray" :key="index" class="row price-breakdown">
                <p class="col-md-5"><b>{{ paymentPart.label }}</b></p>
                <p class="col-md-5">{{ paymentPart.value }}</p>
                <p class="col-md-2">{{ '$' + paymentPart.price }}</p>
              </div>
              <div class="row background-grey">
                <p class="amount col-md-10">
                  <b>{{
                      computeCaption(this.fields_en['amount_to_be_charged'], this.$store.state.lang.value.toLowerCase())
                    }}</b>
                </p>
                <p class="amount col-md-2">{{ 'Total $' + totalAmount }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import {FormatterUtils} from '../../../../../../utils/Formatter'
import {AmountUtils} from '../../../../../../utils/Amount'
import VueBarcode from 'vue-barcode'
import {SettingsUtils} from '../../../../../../utils/SiteConfigurations'
import {TranslationsUtils} from '../../../../../../utils/Translations'
import {QuestionUtils} from '../../../../../../utils/Questions'
import {PatientInfoUtils} from '../../../../../../utils/PatientInfo'
import CardSectionAuthorize from './cardSectionAuthorize'

export default {
  mixins: [FormatterUtils, AmountUtils, SettingsUtils, TranslationsUtils, QuestionUtils, PatientInfoUtils],
  props: ['paymentArray', 'totalAmount'],
  data () {
    return {
      fields_en: {
        amount_to_be_charged: 'Based on your answers, the amount to be charged on credit card:'
      }
    }
  },
  components: {
    CardSectionAuthorize,
    'barcode': VueBarcode
  },
  beforeMount () {
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../assets/sass/paper/variables';
.margin-justified {
  margin-left:20px; margin-right:20px
}
.price-breakdown {
  border: 1px solid $default-grey;
  margin-bottom: 15px;
  padding: 5px 0px;
}
.background-grey {
  background-color: $default-grey;
}

.pc-hidden {
  display: none;
}

#card-errors{
  color: #f83f37;
}

.f-right{
  float: right;
}

.group {
  background: white;
  box-shadow: 0px 1px 3px #E7E8E9 !important;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
}

label {
  position: relative;
  color: #31325F;
  font-weight: 300;
  height: 40px;
  line-height: 40px;
  margin-left: 20px;
  display: flex;
  flex-direction: row;
}

label > span {
  width: 80px;
  text-align: left;
}

.field {
  background: transparent;
  font-weight: 300;
  border: 0;
  color: #31325F;
  outline: none;
  flex: 1;
  padding-right: 10px;
  padding-left: 10px;
  cursor: text;
  padding-top: 0;
}

.radio-label{
  color: #474644;
  font-weight: bold;
  padding: 0;
  margin: 0;
}

.radio {
  margin: 0;
  margin-left: 10px;
}

.mt-6{
  margin-top: 6px;
}

.loading{
  margin-top: 30px;
}

.mt-30 {
  margin-top: 30px;
}

.authorize-elements label {
  margin-bottom: 0;
}

.card-label {
  line-height: 14px;
  font-size: 14px;
  text-align: left;
  display: flex;
  align-items: center;
}

@media screen and (max-width: 550px) {
  label > span {
    width: 40px;
    text-align: left;
    margin-right: 10px;
  }

  .field {
    background: transparent;
    font-weight: 300;
    border: 0;
    color: #31325F;
    outline: none;
    flex: 1;
    padding-right: 10px;
    padding-left: 40px;
    cursor: text;
    padding-top: 0;
  }
}

@media screen and (max-width: 990px) {
  .pc-hidden {
    display: block;
  }
}
@media screen and (max-width: 1720px) {
  .mt-8 {
    margin-top: 0px;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/SubComponents/PaymentParts/paymentDisplay.vue